<template>
  <div>
    <!-- Rainforest Loading -->
    <div
      v-if="rainforestLoading"
      class="w-full my-3 flex justify-center"
    >
      <client-loading-indicator class="text-primary-500 fill-gray-100 w-5 h-5" />
    </div>
    <!-- eslint-disable vue/no-undef-components -->
    <rainforest-payment
      :session-key="paymentRequestData.intent.session.key"
      :payment-method-config-id="paymentRequestData.intent.payment_method_config_id"
      :allowed-methods="allowedMethods"
      @loaded="rainforestLoading = false"
      @approved="paymentMethodApproved"
      :style-button-color="color"
    />
    <!-- eslint-enable vue/no-undef-components -->
    <!-- Disclaimer -->
    <div class="text-gray-400 text-xs text-center mt-1 px-4">
      By providing your payment information you allow {{ companyName }} to charge your payment method for future
      payments.
    </div>
  </div>
</template>

<script>
import paymentMethodRequest from "../../repository/paymentMethodRequest"
import ClientLoadingIndicator from "../../../ClientPortal/client_auth/components/client-loading-indicator.vue"

export default {
  name: "PortalRainforestMethodRequestForm",

  components: { ClientLoadingIndicator },

  props: {
    paymentRequestData: { type: Object, required: true },
    color: { type: String, default: "" },
  },

  emits: ["approve"],

  computed: {
    allowedMethods() {
      return this.paymentRequestData.payment_method_request.allowed_payment_methods
        .map((item) => (item.toLowerCase() === "cc" ? "CARD" : "ACH"))
        .sort()
        .reverse()
        .join(",")
    },

    companyName() {
      return window.FinancialCents.company.name || ""
    },
  },

  data() {
    return {
      rainforestLoading: true,
    }
  },

  methods: {
    async paymentMethodApproved() {
      try {
        const params = this.$route.params
        await paymentMethodRequest.complete(params)
        this.$emit("approve")
      } catch (e) {
        console.error(e)
      } finally {
        this.paymentMethodRequestLoading = false
      }
    },
  },
}
</script>
